import { ROUTES } from 'src/enums';

export default [
  {
    path: '/auth',
    component: () => import('layouts/SpaLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('layouts/AuthLayout.vue'),
        children: [
          {
            path: '',
            name: ROUTES.AUTH,
            component: () => import('pages/auth/AuthPage.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/reset',
    component: () => import('layouts/SpaLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('layouts/AuthLayout.vue'),
        children: [
          {
            path: '',
            name: ROUTES.RESET,
            component: () => import('pages/auth/ResetPage.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/auth/restore-password/confirm/:code',
    component: () => import('layouts/SpaLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('layouts/AuthLayout.vue'),
        children: [
          {
            path: '',
            name: ROUTES.RECOVERY,
            component: () => import('pages/auth/RecoveryPage.vue'),
          },
        ],
      },
    ],
  },
];
